<template>
  <div class="header FTG-Menu">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="dark" active-name="2" style="display: flex;align-items: center;">
          <div class="headerTitle SelectNone">
            <!-- FTG | DELIVER THE EXCELLENCE -->
            FTG | <span style="font-weight: 400;">{{years}} YEARS ARCHITECTURAL VISUALIZATION</span>
          </div>
          <div class="layout-nav SelectNone">
            <MenuItem :to="{path: '/'}" name="2">Works</MenuItem>
            <MenuItem :to="{path: '/about'}" name="3">About</MenuItem>
            <!-- <MenuItem :to="{path: '/workflow'}" name="7">Workflow</MenuItem> -->
            <MenuItem :to="{path: '/team'}" name="6">Team</MenuItem>
            <MenuItem :to="{path: '/news'}" name="5">News</MenuItem>
            <MenuItem :to="{path: '/contact'}" name="4">Contact</MenuItem>
            <div class="links">
              <img src="../assets/image/footer-linkedin.png" @click="linkWeb('https://www.linkedin.com/in/fay-yu-b3659038/')" alt="logo" class="logo-dark">
              <img src="../assets/image/footer-architizer.jpg" @click="linkWeb('https://architizer.com/firms/ftg-studio/')" alt="logo" class="logo-dark">
            </div>
            <!-- <div class="Clear"></div> -->
          </div>
          <Icon @click="showMenu()" class="HeaderMenu" style="margin-top: 0;" type="md-menu" />
        </Menu>
      </Header>
    </Layout>

    <!-- menu -->
    <Modal v-model="menuModal" class="MenuModal" :styles="{top: '0px'}">
      <Collapse simple>
        <Panel name="1">
          Works
          <div slot="content">
            <Button @click="toImgs('all')" type="text">All</Button>
            <Button @click="toImgs('4')" type="text">Award</Button>
            <Button @click="toImgs('a')" type="text">Still Image</Button>
            <Button @click="toImgs('b')" type="text">Animation</Button>
            <Button @click="toImgs('c')" type="text">VR | AR</Button>
          </div>
        </Panel>
      </Collapse>
      <Button @click.native="toPage('/about')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">About</Button>
      <!-- <Button @click.native="toPage('/workflow')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Workflow</Button> -->
      <Button @click.native="toPage('/team')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Team</Button>
      <Button @click.native="toPage('/news')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">News</Button>
      <Button @click.native="toPage('/contact')" class="singalBtn" type="text">Contact</Button>
      <div class="links">
        <img src="../assets/image/footer-linkedin.png" @click="linkWeb('https://www.linkedin.com/in/fay-yu-b3659038/')" alt="logo" class="logo-dark">
        <img src="../assets/image/footer-architizer.jpg" @click="linkWeb('https://architizer.com/firms/ftg-studio/')" alt="logo" class="logo-dark">
      </div>
    </Modal>


  </div>
</template>

<script>
export default {
  name: 'NavHeader',
  props: ['years'],
  data () {
    return {
      menuModal: false
    }
  },
  methods: {
    linkWeb(url){
      window.open(url, '_blank')
    },
    showMenu(){
      this.menuModal = true
    },
    toImgs(str){
      console.log(window.innerHeight)
      document.documentElement.scrollTop = window.innerHeight
      this.menuModal = false

      if(str == 'a'){                    // Still Image
        eventBus.$emit('still');
      }else if(str == 'b'){              // Animation
        eventBus.$emit('animat');
      }else if(str == 'c'){              // VR | AR
        eventBus.$emit('arvr');
      }else if(str == '4'){              // Award
        eventBus.$emit('award');
      }else{                             // All
        eventBus.$emit('alls');
      }
    },
    toPage(_path){
      this.$router.push({path: _path})
    }
  },
  mounted() {

  },
  watch:{
    
  }
}
</script>

<style scoped lang="less">
  @import './component.less';
</style>



// WEBPACK FOOTER //
// src/components/mainHeader.vue